import React from 'react';
import DistributionBarCard from './DistributionBarCard';

const OPTION_BAR_CLASS = {
  Excellent: 'fi-bar-blue',
  Good: 'fi-bar-sky',
  Average: 'fi-bar-yellow',
  'Needs improvement': 'fi-bar-red',
  'Needs Improvement': 'fi-bar-red',
  'Too short': 'fi-bar-muted',
  'Just right': 'fi-bar-green',
  'Slightly too long': 'fi-bar-yellow',
  'Way too long': 'fi-bar-red',
  'Extremely beneficial': 'fi-bar-green',
  'Very beneficial': 'fi-bar-lime',
  'Somewhat beneficial': 'fi-bar-yellow',
  'Slightly beneficial': 'fi-bar-orange',
  'Not beneficial': 'fi-bar-red',
};

const normalizeOptions = (items = [], preferredOrder = []) => {
  const map = new Map(
    items.map((item) => [
      String(item.option || item.Option || '').trim(),
      {
        option: String(item.option || item.Option || '').trim(),
        count: Number(item.count ?? item.Count ?? 0),
        percentage: Number(item.percentage ?? item.Percentage ?? 0),
      },
    ]),
  );

  if (preferredOrder.length === 0) {
    return Array.from(map.values());
  }

  return preferredOrder.map((option) => map.get(option) || { option, count: 0, percentage: 0 });
};

const OptionDistributionCard = ({
  title,
  subtitle,
  icon,
  items = [],
  preferredOrder = [],
  columns = 1,
}) => {
  const normalized = normalizeOptions(items, preferredOrder);

  return (
    <DistributionBarCard
      title={title}
      subtitle={subtitle}
      icon={icon}
      items={normalized}
      columns={columns}
      getLabel={(item) => item.option}
      getCount={(item) => item.count}
      getPercentage={(item) => item.percentage}
      getBarClass={(item) => OPTION_BAR_CLASS[item.option] || 'fi-bar-blue'}
      footer={
        normalized.every((item) => item.count === 0) ? (
          <p className="fi-empty-inline">No responses yet.</p>
        ) : null
      }
    />
  );
};

export default OptionDistributionCard;
